import styled from 'styled-components'

import { ErrorMessage } from '@sketch/components'

export const MessageContainer = styled(ErrorMessage)`
  flex: 1 0 auto;
  padding: 0 16px;
`
